import styled from "styled-components";

export const Page = styled.div`
  font-family: Inter, sans-serif;
  padding-bottom: 32px;
`;

export const PageHeader = styled.div`
  margin-bottom: 18px;
`;

export const PageTitle = styled.h1`
  margin: 0;
  color: #171c35;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
`;

export const PageSubtitle = styled.p`
  margin: 0;
  color: #757575;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
`;

export const Sections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const SectionWrap = styled.div`
  display: flex;
  align-items: stretch;
  width: 100%;
`;

export const AccentRail = styled.div`
  width: 40px;
  flex-shrink: 0;
  background: #e3e9eb;
  border: 1px solid #e8e8e8;
  border-right: none;
  border-radius: 10px 0 0 10px;
`;

export const SectionBody = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 0 10px 10px 0;
  overflow: hidden;
`;

export const SectionHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 17px 19px 16px;
  border-bottom: 1px solid #e8e8e8;
`;

export const SectionHeaderCopy = styled.div`
  flex: 1;
  min-width: 0;
`;

export const SectionStatus = styled.span`
  flex-shrink: 0;
  color: ${(p) =>
    p.$status === "completed"
      ? "#17c653"
      : p.$status === "skipped"
        ? "#a1a5b7"
        : "#5e5e5e"};
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`;

export const SectionTitle = styled.h2`
  margin: 0;
  color: #030f1b;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
`;

export const SectionSubtitle = styled.p`
  margin: 0;
  color: #757575;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
`;

export const PrimaryCta = styled.button`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 27px;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  background: #083b4c;
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
  line-height: 14.8px;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: #0a4a5f;
  }
`;

export const SectionDesc = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 19px 17px;
  color: #667085;
  font-size: 14px;
  font-weight: 400;
  line-height: 22.4px;
`;

export const SectionDescText = styled.span`
  flex: 1;
  min-width: 0;
`;

export const SubStepRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px 20px;
  border-top: 1px solid #e4e6ea;
  background: #ffffff;

  &:last-child {
    border-bottom: none;
  }
`;

export const StepCircle = styled.div`
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f4f5f7;
  border: 1.5px solid #e4e6ea;
  color: #9ca3af;
  font-size: 10px;
  font-weight: 700;
  line-height: 15px;
`;

export const SubStepContent = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  padding-bottom: 4px;
`;

export const SubStepTitleRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
`;

export const SubStepTitle = styled.p`
  margin: 0;
  color: #030f1b;
  font-size: 13px;
  font-weight: 700;
  line-height: 19.5px;
`;

export const SubStepStatus = styled.span`
  flex-shrink: 0;
  color: ${(p) =>
    p.$status === "completed"
      ? "#17c653"
      : p.$status === "skipped"
        ? "#a1a5b7"
        : "#5e5e5e"};
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`;

export const SubStepDesc = styled.p`
  margin: 4px 0 12px;
  color: #667085;
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
`;

export const StartButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  border: 1px solid #e4e6ea;
  border-radius: 8px;
  background: #f4f5f7;
  color: #5e5e5e;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  cursor: pointer;
  width: fit-content;

  &:hover {
    background: #eceef2;
  }
`;

export const LoadingWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 280px;
`;

/* Header chip — Figma 272:5452 */
export const SetupGuideChipButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 6px 12px;
  border: 1px solid #e4e6ea;
  border-radius: 10px;
  background: #ffffff;
  cursor: pointer;
  font-family: Inter, sans-serif;
  box-sizing: border-box;

  &:hover {
    border-color: #d0d5dd;
  }
`;

export const ChipProgress = styled.div`
  position: relative;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ChipCopy = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-width: 84px;
`;

export const ChipTitle = styled.span`
  color: #073b4c;
  font-size: 11px;
  font-weight: 700;
  line-height: 11px;
  white-space: nowrap;
`;

export const ChipRemaining = styled.span`
  margin-top: 2px;
  color: ${(p) => (p.$muted ? "#757575" : "#ff9b53")};
  font-size: 10px;
  font-weight: 400;
  line-height: 10px;
  white-space: nowrap;
`;
